module.exports = __webpack_public_path__ + "img/redvbluelogo.3f604bcc.png";